import { cn } from "@/lib/utils";

export function GlassCard({ className, children, hover = false, testId, ...rest }) {
  return (
    <div
      data-testid={testId}
      className={cn("glass relative", hover && "glass-hover", className)}
      {...rest}
    >
      {children}
    </div>
  );
}

export function GlassPanel({ className, children, ...rest }) {
  return (
    <div className={cn("glass-strong", className)} {...rest}>
      {children}
    </div>
  );
}
